export default __webpack_public_path__ + "static/media/TL03.1.b38e3ab0.mp3";